import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

const useUsers = () => {
  const app = useRealmApp();
  const { users, loading } = useAllUsers(app.currentUser.id);
  return {
    loading,
    users,
  };
};

export default useUsers;

function useAllUsers(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getUsers($ownerId: String!) {
        users(query: { owner_id: $ownerId }) {
          _id
          address1
          address2
          city
          color
          country
          disabled
          email
          image
          lastLogin
          lastName
          name
          owner_id
          password
          phone
          pin
          ref
          roles
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const users = data?.users ?? [];
  return { users, loading };
}
